/**
 * Generated with @muse/import-icons
 * Do not edit directly
 */

import { createIcon } from '../lib/create-icon';

export const FolderIcon = createIcon(
  '0 0 20 20',
  <path d="M2 3h5.5L10 6h8v11H2z" />,
);
